export default {
  currentServices: [],
};
